import { render, staticRenderFns } from "./Block5Item.vue?vue&type=template&id=1bdb4948&scoped=true&"
import script from "./Block5Item.vue?vue&type=script&lang=js&"
export * from "./Block5Item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdb4948",
  null
  
)

export default component.exports